<template>
  <v-dialog v-model="isPopupPeriodic" max-width="800" persistent>
    <v-card class="quick-view">
      <v-card-title class="font-weight-bold px-5">
        Kiểm tra định kỳ
        <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-select
          v-model="valueMonth"
          :items="months"
          @change="getPeriodicsByMonth()"
          outlined
          dense
          prepend-icon="mdi-calendar"
          style="width: 160px"
        />
        <v-data-table
          :headers="homeworkHeaders"
          :items="periodics"
          class="elevation-1"
        >
          <template v-slot:item.name="{ item }">
            <a
              v-if="item.lms_link_practice && item.lms_link_practice !== ''"
              style="font-size:12px"
              :href="item.lms_link_practice"
              target="_blank"
            >
              {{ item.name }}
            </a>
            <span v-else>{{ item.name }}</span>
          </template>

          <template v-slot:item.class_code="{ item }">
            <span>{{ item.class_code }}</span>
          </template>

          <template v-slot:item.time="{ item }">
            <span>{{ formatDateBTVN(item.time) }}</span>
          </template>

          <template v-slot:item.get_score="{ item }">
            <div v-if="Number.isFinite(item.no_correct)">
              <a
                v-if="item.lms_link_practice_result && item.lms_link_practice_result !== ''"
                style="font-size:12px"
                :href="item.lms_link_practice_result"
                target="_blank"
              >
                {{ item.no_correct }}/{{ item.no_question || 0 }}
              </a>
              <span v-else>{{ item.no_correct }}/{{ item.no_question || 0 }}</span>
            </div>
            <span v-else>Chưa làm</span>
          </template>

          <template v-slot:item.listening_score="{ item }">
            <div v-if="item.listening_score && item.listening_score !== ''">
              <a
                v-if="item.lms_link_practice_result && item.lms_link_practice_result !== ''"
                style="font-size:12px"
                :href="item.lms_link_practice_result"
                target="_blank"
              >
                {{ item.listening_score }}
              </a>
              <span v-else>{{ item.listening_score }}</span>
            </div>
            <span v-else>Chưa làm</span>
          </template>

          <template v-slot:item.reading_score="{ item }">
            <div v-if="item.reading_score && item.reading_score !== ''">
              <a
                v-if="item.lms_link_practice_result && item.lms_link_practice_result !== ''"
                style="font-size:12px"
                :href="item.lms_link_practice_result"
                target="_blank"
              >
                {{ item.reading_score }}
              </a>
              <span v-else>{{ item.reading_score }}</span>
            </div>
            <span v-else>Chưa làm</span>
          </template>

          <template v-slot:item.writing_score="{ item }">
            <div v-if="item.writing_score && item.writing_score !== ''">
              <a
                v-if="item.lms_link_practice_result && item.lms_link_practice_result !== ''"
                style="font-size:12px"
                :href="item.lms_link_practice_result"
                target="_blank"
              >
                {{ item.writing_score }}
              </a>
              <span v-else>{{ item.writing_score }}</span>
            </div>
            <span v-else>Chưa làm</span>
          </template>

          <template v-slot:item.speaking_score="{ item }">
            <div v-if="item.speaking_score && item.speaking_score !== ''">
              <a
                v-if="item.lms_link_practice_result && item.lms_link_practice_result !== ''"
                style="font-size:12px"
                :href="item.lms_link_practice_result"
                target="_blank"
              >
                {{ item.speaking_score }}
              </a>
              <span v-else>{{ item.speaking_score }}</span>
            </div>
            <span v-else>Chưa làm</span>
          </template>

          <template v-slot:no-data>Không có dữ liệu</template>

        </v-data-table>
      </v-card-text>
      <v-card-actions class="pa-5 group-btn-comment">
        <v-btn color="error" @click="closeModal()">
          Thoát
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="css" scoped>
.group-btn-comment {
  display: flex;
  float: right;
}
</style>

<script>
import * as moment from 'moment';

export default {
  props: {
    isPopupPeriodic: {
      default: () => false,
    },
    periodics: {
      type: Array,
      default: () => ([]),
    },
    homeworkHeaders: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      valueMonth: (new Date()).getMonth(),
      months: [
        { value: 0, text: 'Tháng 1' },
        { value: 1, text: 'Tháng 2' },
        { value: 2, text: 'Tháng 3' },
        { value: 3, text: 'Tháng 4' },
        { value: 4, text: 'Tháng 5' },
        { value: 5, text: 'Tháng 6' },
        { value: 6, text: 'Tháng 7' },
        { value: 7, text: 'Tháng 8' },
        { value: 8, text: 'Tháng 9' },
        { value: 9, text: 'Tháng 10' },
        { value: 10, text: 'Tháng 11' },
        { value: 11, text: 'Tháng 12' },
      ],
    };
  },
  created() {
    //
  },
  methods: {
    closeModal() {
      this.$emit('closeModalPeriodic');
      this.valueMonth = (new Date()).getMonth();
    },
    formatDateBTVN(date) {
      if (date && date !== '') {
        return moment(date).format('DD/MM/YYYY HH:mm');
      }
      return '--';
    },
    getPeriodicsByMonth() {
      const d = new Date();
      const start = new Date(d.getFullYear(), this.valueMonth, 1);
      const end = new Date(d.getFullYear(), this.valueMonth + 1, 0);
      const startDayOfMonth = moment(start).format('YYYY-MM-DD 00:00:00');
      const endDayOfMonth = moment(end).format('YYYY-MM-DD 23:59:59');
      Bus.$emit('load-periodics-by-month', { startDayOfMonth, endDayOfMonth });
    },
  },
};
</script>
